module.exports = "https://static.wmbcdn.com/uniweb/images/6c426096b24022c7925520a521f9f17a.svg";